import { useState } from "react";
import { Music, X } from "lucide-react";

const GENRES = [
  { label: "Charts", id: "37i9dQZF1DXcBWIGoYBM5M" },
  { label: "Pop", id: "37i9dQZF1DWUa8ZRTfalHk" },
  { label: "Hardstyle", id: "37i9dQZF1DX0pH2SQMRXnC" },
  { label: "Frenchcore", id: "3b9YnVCg1sEUoXlRwQvBV2" },
  { label: "Ballermann", id: "18GHbFy1bRK04e8jCLJm5i" },
  { label: "Techno", id: "37i9dQZF1DX6J5NfMJS675" },
  { label: "Sabaton", id: "37i9dQZF1DZ06evO1XTVWU" },
];

export default function SpotifyPlayer() {
  const [open, setOpen] = useState(false);
  const [genre, setGenre] = useState(GENRES[0]);
  const day = new Date().toISOString().slice(0, 10); // täglicher Cache-Buster

  return (
    <div className="fixed right-4 bottom-4 z-50" data-testid="spotify-bubble-wrap">
      {/* Panel – bleibt immer gemountet, damit die Musik beim Zuklappen weiterläuft */}
      <div
        className={`absolute right-0 bottom-12 w-72 border border-zinc-800 rounded-lg bg-[#0C0E12] shadow-2xl shadow-black/60 overflow-hidden transition-all duration-200 ${
          open ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <div className="flex items-center gap-2 px-3 py-2.5 border-b border-zinc-800">
          <Music className="h-4 w-4 text-emerald-400" />
          <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-300">Musik</span>
          <button
            data-testid="spotify-close"
            onClick={() => setOpen(false)}
            className="ml-auto h-6 w-6 grid place-items-center rounded-sm text-zinc-500 hover:text-zinc-200 hover:bg-zinc-800 transition-colors duration-150"
            title="Zuklappen (läuft weiter)"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
        <div className="p-2.5 space-y-2.5">
          <div className="flex flex-wrap gap-1">
            {GENRES.map((g) => (
              <button
                key={g.id}
                data-testid={`spotify-genre-${g.label.toLowerCase()}`}
                onClick={() => setGenre(g)}
                className={`px-2 py-0.5 rounded-sm text-[10px] font-mono uppercase tracking-wide transition-colors duration-150 ${
                  genre.id === g.id
                    ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/40"
                    : "bg-zinc-900 text-zinc-500 border border-zinc-800 hover:text-zinc-300"
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>
          <iframe
            key={genre.id}
            data-testid="spotify-iframe"
            title={`Spotify · ${genre.label}`}
            src={`https://open.spotify.com/embed/playlist/${genre.id}?utm_source=sadcr&theme=0&t=${day}`}
            width="100%"
            height="352"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            className="rounded-sm"
          />
          <p className="text-[9px] leading-tight text-zinc-600 px-0.5">
            Lautstärke über den Regler im Player bzw. dein System · läuft beim Zuklappen weiter.
          </p>
        </div>
      </div>

      {/* Blase mit Musiknote */}
      <button
        data-testid="spotify-toggle"
        onClick={() => setOpen((o) => !o)}
        title="Musik"
        className={`h-10 w-10 rounded-full grid place-items-center shadow-lg shadow-black/50 border transition-all duration-200 hover:scale-110 ${
          open
            ? "bg-emerald-500 border-emerald-400 text-black"
            : "bg-[#0C0E12] border-emerald-500/50 text-emerald-400 hover:border-emerald-400"
        }`}
      >
        <Music className={`h-4 w-4 ${open ? "" : "animate-pulse"}`} />
      </button>
    </div>
  );
}
